module.exports = __webpack_public_path__ + "static/media/clock.a8e1c80a.svg";